<template>
  <transition
    enter-class="fade"
    enter-to-class="fade in"
    leave-to-class="fade"
  >
    <div
      v-if="open"
      class="eartag-backdrop"
      @click.self="dismissible && $emit('close')"
    >
      <div class="eartag-modal fade in" style="transition-delay: 2s !important;">
        <div style="position: relative; width: 100%; height: 100%;">
          <button
            type="button"
            title="Close"
            class="close-button"
            v-if="dismissible"
            @click="dismissible && $emit('close')">
            <svg
              style="max-width: 100%; height: auto;"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 357 357"
            >
              <polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"/>
            </svg>
          </button>

          <div style="padding: 1em">
            <slot/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    dismissible: {
      type: Boolean,
      default: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
    preventBackgroundScrolling: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    if(this.dismissible) {
      document.addEventListener('keydown', this.onEscape);
    }
  },

  destroyed() {
    if(this.dismissible) {
      document.removeEventListener('keydown', this.onEscape);
    }
  },

  methods: {
    onEscape(event) {
      if (!this.open || event.keyCode !== 27) { // escape
        return;
      }

      this.$emit('close');
    },
  },

  watch: {
    open: {
      immediate: true,
      handler(newState) {
        if(this.preventBackgroundScrolling) {
          if(newState) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
          } else {
            document.documentElement.style.overflow = null;
            document.body.style.overflow = null;
          }
        }
      },
    },
  },
}
</script>

<style scoped>
.eartag-backdrop {
  background-color: rgba(0, 0, 0, .4);
  bottom: 0;
  left: 0;
  overflow-y: auto;
  padding: 30px 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1000;
}

.eartag-modal {
  background-color: #FFF;
  border-radius: .25em;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: 42em;
  width: 100%;
}

.close-button {
  background: none;
  border: 0;
  color: rgba(0, 0, 0, .4);
  height: 2.5em;
  margin: .5em .5em 0 0;
  padding: .5em;
  position: absolute;
  right: 0;
  top: 0;
  width: 2.5em;
}
.close-button:focus,
.close-button:hover {
  color: rgba(0, 0, 0, .5);
  outline: none;
}
</style>
